import { render, staticRenderFns } from "./NewSheme.vue?vue&type=template&id=9ca466ac&scoped=true&"
import script from "./NewSheme.vue?vue&type=script&lang=js&"
export * from "./NewSheme.vue?vue&type=script&lang=js&"
import style0 from "./NewSheme.vue?vue&type=style&index=0&id=9ca466ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca466ac",
  null
  
)

export default component.exports